import "../style/page/packages.scss";
import { Packagesget, updatepackages, packagesexcel } from "../../text/apidata";
import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { Tooltip as ReactTooltip } from "react-tooltip";
import PackagesForm from "../form/packagesform";
import BasicTable from "../maincomponent/reacttable/table";
import { packages, packagesid, sidebar } from "../redux/reducer/counterslice";
import Swal from "sweetalert2";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";

export default function Packages(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const packagesstate = useSelector((state) => state.counter.packages);
  const packagesstateid = useSelector((state) => state.counter.packagesid);
  let roledata = localStorage.getItem("role");
  const [isactivefilterdata, setisactivefilterdata] = useState("")
  const locationid = useSelector((state) => state.counter.loginuser_location_id)

  const [branches, setbranches] = useState(locationid != "all" ? locationid : "91");

  const dispatch = useDispatch();
  const dispatchid = useDispatch();

  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };
  const dropdownhandlechange = (id, e) => {
    dispatch(packagesid(id));
    dispatchid(packages("Edit"));
  };
  const creatfunction = () => {
    dispatchid(packages("Create"));
  };
  useEffect(() => {
    if (searchQuery != "") {

      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(searchQuery);
      if (hasNumbers || hasLetters || hasSpecialChars) {

        props.loaderchange("true");

        axios({
          method: "get",
          url: Packagesget,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            is_active: isactivefilterdata,
            branch: branches,


          },
        })
          .then((res) => {
            console.log(res);
            settableheaderdata(res.data.data);
            setdatacount(res.data.data_count);
            props.loaderchange("false");
          })
          .catch((error) => {
            props.loaderchange("false");

          });
      }
    } else {
      props.loaderchange("true");

      axios({
        method: "get",
        url: Packagesget,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          is_active: isactivefilterdata,
          branch: branches,


        },
      })
        .then((res) => {
          console.log(res);
          settableheaderdata(res.data.data);
          setdatacount(res.data.data_count);
          props.loaderchange("false");
        })
        .catch((error) => {
          props.loaderchange("false");

        });
    }
  }, [dtpageindex, dtpagesize, searchQuery, packagesstate, isactivefilterdata, branches]);

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "",
        Cell: (row) => {
          console.log(row.row.original.id)
          const shorten =
            row.row.original.id.toString().length > 20
              ? `${row.row.original.id.toString().substring(0, 10)}...`
              : `${row.row.original.id.toString()}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.id}
              >
                {shorten}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(String(row.row.original.id));
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      // {
      //   Header: "Category",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         <p
      //           data-tooltip-id="my-tooltip"
      //           data-tooltip-content={row.row.original.category}
      //         >
      //           {row.row.original.category}
      //         </p>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Description",
        accessor: "",
        Cell: (row) => {
          const items = [];
          items.push(row.row.original.description);
          // console.log(items.toString());
          const shorten =
            items.toString().length > 20
              ? `${items.toString().substring(0, 15)}...`
              : `${items.toString()}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${items.toString()}`}
              >
                {/* {shorten}{" "} */}
                {row.row.original.description}
              </p>
            </>
          );
        },
      },
      {
        Header: "Category Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.category_name}
              >
                {row.row.original.category_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "Sub Category Name",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.sub_category_name}
              >
                {row.row.original.sub_category_name}
              </p>
            </>
          );
        },
      },

      {
        Header: "Location Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.location_name}
              >
                {row.row.original.location_name}
              </p>
            </>
          );
        },
      },

      {
        Header: "Active",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.is_active == false
                    ? "No"
                    : "Yes"
                }
              >
                {row.row.original.is_active == false ? (
                  <p style={{ color: "red", fontWeight: 700 }}>No</p>
                ) : (
                  <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                )}
              </p>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const getdata = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want to Update Data ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "get",
          url: updatepackages,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Data Has Been Upadated',
              showConfirmButton: false,
              timer: 1500
            })

          })
          .catch((error) => { });
      }
    });
  }

  const datadownload = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Do You Want To Download The Data?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: 'get',
          url: packagesexcel,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        }).then((res) => {
          window.open(res.data.data, '_self')
          // Swal.fire(
          //   'Deleted!',
          //   'Your file has been deleted.',
          //   'success'
          // )

          console.log(res)

        }).catch((err) => {

        })
      }
    })
  }
  return (
    <>
      <div className={sideactive ? "packages-sa" : "packages"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Packages</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"))
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Packages</li>
              </ul>
            </div>
            <div class="col-sm-5 col">
              <a
                onClick={(e) => creatfunction(e)}
                style={{
                  backgroundColor: "#1b5a90",
                  border: "1px solid #1b5a90",
                  color: "white",
                }}
                data-toggle="modal"
                class="btn btn-primary float-right mt-2"
              >
                Add
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form onSubmit={handleSubmit}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) { e.preventDefault(); }
                      }}

                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);

                        }
                        else {
                          e.preventDefault()
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                  <div>
                    {/* <button className="getdata" onClick={(e)=>{
                    getdata()
                  }}>
                    <div class="spinner">
                      <i class="bi bi-chevron-double-down"></i>
                    </div>
                    Update Packages Data
                  </button> */}
                    <div align="center" type="button" >
                      <a class="dnbtn"
                        onClick={(e) => {
                          datadownload();
                        }}></a>
                    </div>
                  </div>

                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                    isactive={true}
                    isactivefilterdata={isactivefilterdata}
                    setisactivefilterdata={setisactivefilterdata}
                    location={"others"}
                    setbranches={setbranches}
                    branches={branches}


                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {packagesstate == "Edit" || packagesstate == "Create" ? (
        <PackagesForm
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}
        />
      ) : (
        ""
      )}
    </>
  );
}
